import { Box, Grid, Typography } from "@mui/material";

export default function DetailCell({
	label,
	value,
	children
}: {
	label: string;
	value?: string;
	children?: React.ReactNode;
}) {
	return (
		<Grid size={{ xs: 6, sm: 6 }}>
			<Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
				<Typography
					variant="text12Bold"
					color="secondary.light50"
					sx={{ textTransform: "uppercase" }}
				>
					{label}
				</Typography>
				{children ?? <Typography variant="text14">{value}</Typography>}
			</Box>
		</Grid>
	);
}
